import { BATTLE_RULES } from "../content/battles";

/*
  Coins are earned only by playing (brief, principle 5). Each event carries
  the coins it earned under the rules at the time, and a child's total is the
  sum, so retuning these never rewrites a balance. Pure.
*/

/**
 * A battle pays its points, plus the enemy's health in points for a win,
 * plus a worn Lucky Charm's share of that (rounded up).
 */
export function battleCoins(points: number, won: boolean, enemyHealth: number, share = 0): number {
  const base = points + (won ? Math.round(enemyHealth / BATTLE_RULES.hitPointsPerPoint) : 0);
  return Math.ceil(base * (1 + share));
}

/** Practice pays a trickle: one coin per few right answers. */
export function practiceCoins(score: number): number {
  return Math.floor(score / BATTLE_RULES.practiceAnswersPerCoin);
}

/** A trial pays only the first time it's passed in a strand, by rank number. */
export function trialCoins(rankIndex: number, firstPass: boolean): number {
  return firstPass ? rankIndex * BATTLE_RULES.trialPassCoinsPerRank : 0;
}

/**
 * The most coins any round can honestly earn from `score` right answers. The
 * database enforces the same cap, so a made-up total is refused. A Legend win
 * on all tier-5 questions with a level-3 Lucky Charm reaches 7.5 × score + 99.
 */
export function coinCap(score: number): number {
  return 8 * score + 150;
}
